<template>
    <v-layout wrap>
        <v-flex class="mb-4 d-flex align-items-center">
            <div>
                <h1 class="d-inline-block vertical-align-middle">{{ $t('log-file') }}</h1>
                <v-tooltip bottom>
                    <v-btn icon flat slot="activator">
                        <v-icon>mdi-help-circle</v-icon>
                    </v-btn>
                    <span>{{ $t('help') }}</span>
                </v-tooltip>
                <!--<v-tooltip bottom>
                    <v-btn @click="OpenReport()" flat icon slot="activator">
                        <v-icon>mdi-file-chart</v-icon>
                    </v-btn>
                    <span>{{ $t('report') }}</span>
                </v-tooltip>-->
            </div>
        </v-flex>

        <!-- Search box -->
        <v-form class="flex xs12 mb-3" @submit.prevent="onFilter">
            <v-flex xs12>
                <v-card class="pa-3 mb-3">
                    <v-container grid-list-lg>
                        <v-layout wrap>
                            <v-flex md4 sm6 xs12>
                                <v-menu ref="menu"
                                        v-model="datepicker1"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px">
                                    <v-text-field slot="activator"
                                                  v-model="logFile.fromDate"
                                                  :label="$t('from-date')"
                                                  prepend-icon="event"
                                                  readonly></v-text-field>
                                    <v-date-picker ref="picker"
                                                   v-model="logFile.fromDate"
                                                   min="1900-01-01"
                                                   :max="new Date().toISOString().substr(0, 10)"
                                                   @change="saveDate"></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex md4 sm6 xs12>
                                <v-menu ref="menu"
                                        v-model="datepicker2"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px">
                                    <v-text-field slot="activator"
                                                  v-model="logFile.toDate"
                                                  :label="$t('to-date')"
                                                  prepend-icon="event"
                                                  readonly></v-text-field>
                                    <v-date-picker ref="picker"
                                                   v-model="logFile.toDate"
                                                   min="1900-01-01"
                                                   :max="new Date().toISOString().substr(0, 10)"
                                                   @change="saveDate"></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <!--<v-flex md4 sm6 xs12>
        <v-menu ref="menu"
                v-model="timepicker1"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px">
            <v-text-field slot="activator"
                          v-model="logFile.fromTime"
                          :label="$t('from-time')"
                          prepend-icon="event"
                          readonly></v-text-field>
            <v-time-picker ref="picker"
                           v-model="logFile.fromTime"
                           full-width
                           @change="$refs.menu.save()"></v-time-picker>
        </v-menu>
    </v-flex>
    <v-flex md4 sm6 xs12>
        <v-menu ref="menu"
                v-model="timepicker2"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px">
            <v-text-field slot="activator"
                          v-model="logFile.toTime"
                          :label="$t('to-time')"
                          prepend-icon="event"
                          readonly></v-text-field>
            <v-time-picker ref="picker"
                           v-model="logFile.toTime"
                           full-width
                           @change="$refs.menu.save()"></v-time-picker>
        </v-menu>
    </v-flex>-->

                            <v-flex md4 sm6 xs12>
                                <v-autocomplete :label="$t('system')"
                                                :items="systemList"
                                                v-model="logFile.samaSystemId"
                                                :item-text="getLabelByLang('enLabel', 'arLabel')"
                                                clearable
                                                item-value="code"
                                                @change="getModules"></v-autocomplete>
                            </v-flex>

                            <v-flex md4 sm6 xs12>
                                <v-autocomplete :label="$t('module')"
                                                :items="moduleList"
                                                v-model="logFile.moduleID"
                                                :item-text="getLabelByLang('enLabel', 'arLabel')"
                                                clearable
                                                item-value="code"
                                                 @change="getPages"></v-autocomplete>
                            </v-flex>
                            
                            <v-flex md4 sm6 xs12>
                                <v-autocomplete :label="$t('page')"
                                                :items="pageList"
                                                v-model="logFile.pageID"
                                                :item-text="getLabelByLang('enLabel', 'arLabel')"
                                                clearable
                                                item-value="id"></v-autocomplete>
                            </v-flex>

                            <v-flex md4 sm6 xs12>
                                <v-autocomplete :label="$t('select-action')" v-model="logFile.actionID" clearable :items="actions">
                                    <template slot="selection" slot-scope="data">
                                        {{ $t(data.item.name) }}
                                    </template>
                                    <template slot="item" slot-scope="data">
                                        {{ $t(data.item.name) }}
                                    </template>
                                    <template slot="item" slot-scope="data">
                                        {{ $t(data.item.name) }}
                                    </template>
                                    <template slot="item" slot-scope="data">
                                        {{ $t(data.item.name) }}
                                    </template>
                                </v-autocomplete>
                            </v-flex>

                            <!--<v-flex md4 sm6 xs12>
        <v-autocomplete :label="$t('group')"
                  :items="groupList"
                  v-model="logFile.groupId"
                  :item-text="getLabelByLang('enName', 'arName')"
                                clearable
                  item-value="id"></v-autocomplete>
    </v-flex>
    <v-flex md4 sm6 xs12>
        <v-autocomplete :label="$t('company')"
                  :items="companyList"
                  v-model="logFile.companyId"
                  :item-text="getLabelByLang('enName', 'arName')"
                                clearable
                  item-value="id"></v-autocomplete>
    </v-flex>
    <v-flex md4 sm6 xs12>
        <v-autocomplete :label="$t('branch')"
                  :items="branchList"
                  v-model="logFile.branchId"
                  :item-text="getLabelByLang('enName', 'arName')"
                                clearable
                  item-value="id"></v-autocomplete>
    </v-flex>
    <v-flex md4 sm6 xs12>
        <v-autocomplete :label="$t('gallery')"
                  :items="galleryList"
                  v-model="logFile.gallaryID"
                  :item-text="getLabelByLang('enName', 'arName')"
                                clearable
                  item-value="id"></v-autocomplete>
    </v-flex>-->
                            <!--<v-flex md4 sm6 xs12>
        <v-text-field :label="$t('ip-address')" v-model="logFile.ipAdress"></v-text-field>
    </v-flex>-->

                            <v-flex md4 sm6 xs12>
                                <v-autocomplete :label="$t('user-id')"
                                                :items="userList"
                                                v-model="logFile.createdBy"
                                                :item-text="getLabelByLang('arFullName', 'enFullName')"
                                                clearable
                                                item-value="id"></v-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <v-flex xs12>
                                    <v-btn color="primary" type="submit">{{ $t('filter') }}</v-btn>
                                    <v-btn color="primary" type="reset" @click="filterInit()">{{ $t('reset') }}</v-btn>
                                </v-flex>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card>
            </v-flex>
        </v-form>
        <!-- Data Table -->
        <v-flex xs12 class="mb-3">
            <v-data-table :loading="isLoading"
                          :headers="headers"
                          :items="logFiles"
                          class="elevation-1"
                          item-key="logFileId">
                <template slot="items" slot-scope="props">
                    <td>{{ props.item.fullName }}</td>
                    <td>{{ props.item.describtion }}</td>
                    <td>{{ props.item.pageName }}</td>
                    <td>{{ props.item.actionName }}</td>
                    <td>{{ props.item.createdAt | date }}</td>
                </template>
            </v-data-table>
        </v-flex>
    </v-layout>
</template>

<script>
    import LogFileService from "@/services/LogFileService";
    import SystemService from "@/services/SystemService";
    import ModuleService from "@/services/ModuleService";
    import PageService from "@/services/PageService";
    import GroupService from "@/services/AdminSystem/OrganizationStructure/GroupService";
    import CompanyService from "@/services/AdminSystem/OrganizationStructure/CompanyService";
    import BranchService from "@/services/AdminSystem/OrganizationStructure/BranchService";
    import GalleryService from "@/services/AdminSystem/OrganizationStructure/GalleryService";
    import UserService from "@/services/UserService";
    import SettingOrgService from "@/services/AdminSystem/OrganizationStructure/SettingOrgService";

    export default {
        name: "logFile-list",
        data() {
            return {
                selected: [],
                logFiles: [],
                isLoading: false,
                logFile: {
                    keyword: "",
                    source: 0,
                    fromDate: new Date().toISOString().substr(0, 10),
                    toDate: new Date().toISOString().substr(0, 10),
                    //fromTime: new Date().toISOString().substr(0, 10),
                    //toTime: new Date().toISOString().substr(0, 10),
                    samaSystemId: 0,
                    moduleID: 0,
                    pageID: 0,
                    actionID: 0,
                    groupId: 0,
                    companyId: 0,
                    branchId: 0,
                    gallaryID: 0,
                    ipAddress: "",
                    createdBy: 0
                },
                datepicker1: false,
                datepicker2: false,
                timepicker1: false,
                timepicker2: false,
                systemList: [],
                moduleList: [],
                pageList: [],
                groupList: [],
                companyList: [],
                branchList: [],
                galleryList: [],
                userList: [],
                actions: [
                    { value: 1, name: "view" },
                    { value: 2, name: "Add" },
                    { value: 3, name: "Edit" },
                    { value: 4, name: "delete" },
                    //{ value: 5, text: "Post" },
                    //{ value: 6, text: "Un Post" },
                    //{ value: 7, text: "Log" },
                    //{ value: 8, text: "Report" },
                    //{ value: 9, text: "Change Add Compsit Key" }
                ]
            };
        },
        async created() {
            this.getSystems();
            this.getModules();
            this.getPages();
            this.getGroups();
            this.getCompanies();
            this.getBranches();
            this.getGalleries();
            this.getUsers();
            this.isLoading = true;
            const logFiles = (await LogFileService.getLogFiles(this.logFile)).data;
            this.logFiles = logFiles;
            this.isLoading = false;
        },
        methods: {
            async getLogFiles() {
                this.logFiles = [];
                this.isLoading = true;
                const logFiles = (await LogFileService.getLogFiles(this.logFile)).data;
                this.logFiles = logFiles;
                this.isLoading = false;
            },
            async  filterInit() {
                this.logFile.keyword = "";
                this.logFile.source = 0;
                this.logFile.fromDate = new Date().toISOString().substr(0, 10);
                this.logFile.toDate = new Date().toISOString().substr(0, 10);
                this.logFile.samaSystemId = 0;
                this.logFile.moduleID = 0;
                this.logFile.pageID = 0;
                this.logFile.actionID = 0;
                this.logFile.groupId = 0;
                this.logFile.companyId = 0;
                this.logFile.branchId = 0;
                this.logFile.gallaryID = 0;
                this.logFile.ipAddress = "";
                this.logFile.createdBy = 0;
                await this.getLogFiles();
            },
            saveTime() {
                this.$refs.menu.save();
            },
            saveDate(date) {
                this.$refs.menu.save(date);
            },
            async getSystems() {
                this.systemList = (await SystemService.getSystems()).data;
            },
            async getModules(code) {
                this.moduleList = (await ModuleService.GetModuleByCriteria({keyword:'', codeSAMASystem:code})).data;
            },
            async getPages(code) {
                this.pageList = (await PageService.GetPageByCriteria({keyword:'', codeModuleID:code})).data;
            },
            async getGroups() {
                this.groupList = (await GroupService.getGroups()).data;
            },
            async getCompanies() {
                this.companyList = (await CompanyService.getCompanies()).data;
            },
            async getBranches() {
                this.branchList = (await BranchService.getBranches()).data;
            },
            async getGalleries() {
                this.galleryList = (await GalleryService.getGalleries()).data;
            },
            async getUsers() {
                this.userList = (await UserService.getUsers()).data;
            },
            async onFilter() {
                const isValid = await this.$validator.validateAll();
                if (!isValid) return;

                await this.getLogFiles();
            },
            async OpenReport() {
                const settingOrg = (await SettingOrgService.GetSettingOrganizationByUserId()).data;
                if (settingOrg) {
                    window.open(settingOrg.reportURL + 'Admin/Page/logTransactionReport.aspx', '_blank');
                }
            },
        },
        computed: {
            selectedIds() {
                return this.selected.map(logFile => ({ id: logFile.id }));
            },
            headers() {
                return [
                    { text: this.$t("createdBy"), value: "fullName", sortable: false },
                    { text: this.$t("desc"), value: "describtion", sortable: false },
                    { text: this.$t("page"), value: "pageName", sortable: false },
                    { text: this.$t("action"), value: "actionName", sortable: false },
                    { text: this.$t("TransactionDate"), value: "createdAt", sortable: false }
                ];
            }
        }
    };
</script> 